pRODOTTI// Per la documentazione completa API, inclusi esempi di codici, visita https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});